import Vue from 'vue'
import { JSEncrypt } from 'jsencrypt/lib/JSEncrypt'
function common() {}
//存储cookie
common.prototype.setCookie = (cname, cvalue, exdays) => {
    let d = new Date()
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    let expires = 'expires=' + d.toUTCString()
    console.info(cname + '=' + cvalue + '; ' + expires)
    document.cookie = cname + '=' + cvalue + '; ' + expires
}
//获取cookie
common.prototype.getCookie = cname => {
    let name = cname + '='
    let ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) == ' ') c = c.substring(1)
        if (c.indexOf(name) != -1) return c.substring(name.length, c.length)
    }
    return ''
}
//清理cookie
common.prototype.clearCookie = name => {
    common.prototype.setCookie(name, '', -1)
}

//loading
let loaded
common.prototype.startLoading = (index, dom) => {
    loaded = Vue.prototype.$loading({
        lock: true,
        text: 'Loading',
        fullscreen: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        target: '.content-wrapper'
    })
}
common.prototype.endLoading = (index, dom) => {
    loaded.close()
}
//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0
common.prototype.showFullScreenLoading = () => {
    if (needLoadingRequestCount === 0) {
        common.prototype.startLoading()
    }
    needLoadingRequestCount++
}
common.prototype.tryHideFullScreenLoading = () => {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        common.prototype.endLoading()
    }
}
//数组排序
common.prototype.sortArr = (arr, key) => {
    arr.sort((a, b) => {
        return a[key] - b[key]
    })
    return arr
}

//base64加解密
common.prototype.Base64 = {
    // private property
    _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

    // public method for encoding
    encode: function (input) {
        let output = ''
        let chr1, chr2, chr3, enc1, enc2, enc3, enc4
        let i = 0
        input = common.prototype.Base64._utf8_encode(input)
        while (i < input.length) {
            chr1 = input.charCodeAt(i++)
            chr2 = input.charCodeAt(i++)
            chr3 = input.charCodeAt(i++)
            enc1 = chr1 >> 2
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
            enc4 = chr3 & 63
            if (isNaN(chr2)) {
                enc3 = enc4 = 64
            } else if (isNaN(chr3)) {
                enc4 = 64
            }
            output =
                output +
                this._keyStr.charAt(enc1) +
                this._keyStr.charAt(enc2) +
                this._keyStr.charAt(enc3) +
                this._keyStr.charAt(enc4)
        }
        return output
    },
    // public method for decoding
    decode: function (input) {
        let output = ''
        let chr1, chr2, chr3
        let enc1, enc2, enc3, enc4
        let i = 0
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '')

        while (i < input.length) {
            enc1 = this._keyStr.indexOf(input.charAt(i++))
            enc2 = this._keyStr.indexOf(input.charAt(i++))
            enc3 = this._keyStr.indexOf(input.charAt(i++))
            enc4 = this._keyStr.indexOf(input.charAt(i++))

            chr1 = (enc1 << 2) | (enc2 >> 4)
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
            chr3 = ((enc3 & 3) << 6) | enc4

            output = output + String.fromCharCode(chr1)

            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2)
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3)
            }
        }
        output = common.prototype.Base64._utf8_decode(output)
        return output
    },
    // private method for UTF-8 encoding
    _utf8_encode: function (string) {
        string = string.replace(/\r\n/g, '\n')
        let utftext = ''

        for (let n = 0; n < string.length; n++) {
            let c = string.charCodeAt(n)

            if (c < 128) {
                utftext += String.fromCharCode(c)
            } else if (c > 127 && c < 2048) {
                utftext += String.fromCharCode((c >> 6) | 192)
                utftext += String.fromCharCode((c & 63) | 128)
            } else {
                utftext += String.fromCharCode((c >> 12) | 224)
                utftext += String.fromCharCode(((c >> 6) & 63) | 128)
                utftext += String.fromCharCode((c & 63) | 128)
            }
        }
        return utftext
    },

    // private method for UTF-8 decoding
    _utf8_decode: function (utftext) {
        let string = ''
        let i = 0
        let c1, c2, c3
        let c = (c1 = c2 = 0)

        while (i < utftext.length) {
            c = utftext.charCodeAt(i)

            if (c < 128) {
                string += String.fromCharCode(c)
                i++
            } else if (c > 191 && c < 224) {
                c2 = utftext.charCodeAt(i + 1)
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
                i += 2
            } else {
                c2 = utftext.charCodeAt(i + 1)
                c3 = utftext.charCodeAt(i + 2)
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
                i += 3
            }
        }

        return string
    }
}

//判断跳转
common.prototype.message = index => {
    let obj = {
        type: '',
        message: '',
        showClose: true,
        duration: 3000,
        dangerouslyUseHTMLString: true,
        onClose: function (msg) {
            if (index.status == '10000006') {
                location.href = '/'
            }
        }
    }
    let objArr = Object.assign({}, obj, index)
    Vue.prototype.$notify(objArr)
}

// 导航菜单排序
common.prototype.sortMenuNav = arr => {
    let sortField = `sort_order`
    let compareDigital = function (field) {
        return function (i, j) {
            return Number(i[field]) - Number(j[field])
        }
    }
    arr.sort(compareDigital(sortField))

    arr.forEach(function (item, i) {
        if (item.nodes && item.nodes.length > 0) {
            item.nodes.sort(compareDigital(sortField))
            common.prototype.sortMenuNav(item.nodes)
        }
    })
}
common.prototype.JSEncrypt = {
    _keyStr:
        'MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgGjbQmQIoI9o9YLNQnyBtC/Ebacc/RtdofCsQIas3+VIyFeXhsjP9cQUZUJMqBb3hJ+PQ0xsNFP7ysly3kQB6y5+GdTlZVnfrr9Imf0kmIhRHx6+GGheOARaUiYseitgpyTK6P5H+NEgDZ9MYlJ3W/WbKzJhDApSM4kQLhAGRNevAgMBAAE=',
    encryptByPublicKey: function (val = '') {
        if (val === '') {
            return ''
        }
        let encryptor = new JSEncrypt() // 新建JSEncrypt对象
        encryptor.setPublicKey(this._keyStr) // 设置公钥
        return encryptor.encrypt(val) // 对需要加密的数据进行加密
    }
}
let newCommon = new common()
export { newCommon }
